import { render, staticRenderFns } from "./Statistic.vue?vue&type=template&id=1cd4c1f0&scoped=true"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"
import style0 from "./Statistic.vue?vue&type=style&index=0&id=1cd4c1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd4c1f0",
  null
  
)

export default component.exports